class StaffMembersFilter extends HTMLElement {
  constructor() {
    super();

    this.staffMembers = document.querySelectorAll(".staff-section__member");

    this.filters = this.querySelectorAll(".staff-section__filter-item");

    this.addEventListener("click", (e) => {
      if (this.classList.contains("open")) {
        this.classList.remove("open");
      } else {
        this.classList.add("open");
      }
    });

    console.log("  this.staffMembers", this.staffMembers);

    this.filterStaffMembers = this.filterStaffMembers.bind(this);

    this.filters.forEach((filter) => {
      filter.addEventListener("click", (e) => {
        filter.classList.add("active");
        this.filterStaffMembers(filter.dataset.department);

        this.filters.forEach((otherFilter) => {
          if (otherFilter !== filter) {
            otherFilter.classList.remove("active");
          }
        });
        filter.blur();
        this.blur();
      });
    });
  }

  filterStaffMembers(filter) {
    console.log("staffMembers", this.staffMembers);
    this.staffMembers.forEach((staffMember) => {
      console.log("staffMember", staffMember);
      staffMember.classList.add("hidden");
      if (staffMember.classList.contains(filter)) {
        staffMember.classList.remove("hidden");
      }

      if (filter === "all") {
        staffMember.classList.remove("hidden");
      }
    });
  }
}

customElements.define("staff-members-filter", StaffMembersFilter);
